export default __webpack_public_path__ + "static/media/AR.49d3a2aa.svg";